"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const api_external_contract_js_1 = require("@tableau/api-external-contract-js");
const TableauError_1 = require("./TableauError");
/**
 * Represents the current version of the extensions, embedding
 * and extensions-api-types library
 */
class VersionNumber {
    // private constructor so everyone uses the singleton instance
    // build numbers have this form: M.m.f-pre.N
    constructor(versionString, isAlpha) {
        const partStr = versionString.split('-');
        this.build = this.getBuildNumber(partStr[1]);
        versionString = partStr[0];
        const parts = versionString.split('.').map((p) => parseInt(p, 10));
        if (parts.length !== 3) {
            throw new TableauError_1.TableauError(api_external_contract_js_1.ErrorCodes.InternalError, `Invalid version number: ${versionString}`);
        }
        this.major = parts[0];
        this.minor = parts[1];
        this.fix = parts[2];
        this.isAlpha = isAlpha;
    }
    getBuildNumber(preReleaseString) {
        const noBuildNumber = -1;
        if (!preReleaseString) {
            return noBuildNumber;
        }
        // The preRelease string has this form: pre.N, but we don't depend on the actual string being 'pre'
        const partStr = preReleaseString.split('.');
        return partStr[1] ? parseInt(partStr[1], 10) : noBuildNumber;
    }
    get formattedValue() {
        return `${this.major}.${this.minor}.${this.fix}`;
    }
    get fullFormattedValue() {
        return `${this.major}.${this.minor}.${this.fix}-pre.${this.build}`;
    }
}
exports.VersionNumber = VersionNumber;
//# sourceMappingURL=VersionNumber.js.map